const DOOR_SELECTION_PATIENT: string = "DOOR_TOKEN_SELECTION_PATIENT"
const DOOR_SELECTION_VALUE_TYPE: string = "DOOR_TOKEN_SELECTION_VALUE_TYPE"
const DOOR_SELECTION_LOCATION: string = "DOOR_TOKEN_SELECTION_LOCATION"

export function persistPatientSelection(patient: string | null) {
    if(patient) {
        localStorage.setItem(DOOR_SELECTION_PATIENT, patient)
        console.log("persisted patient ", patient)
    }
}

export function getPersistedPatientSelection(): string | null {
    return localStorage.getItem(DOOR_SELECTION_PATIENT)
}

export function persistValueTypeSelection(valueType: string | null) {
    if(valueType) {
        localStorage.setItem(DOOR_SELECTION_VALUE_TYPE, valueType)
        console.log("persisted value type ", valueType)
    }
}

export function getPersistedValueTypeSelection(): string | null {
    return localStorage.getItem(DOOR_SELECTION_VALUE_TYPE)
}

export function persistLocationSelection(location: string) {
    localStorage.setItem(DOOR_SELECTION_LOCATION, location)
    console.log("persisted location ", location)
}

export function getPersistedLocationSelection(): string | null {
    return localStorage.getItem(DOOR_SELECTION_LOCATION)
}